import { useCallback, useLayoutEffect, useRef } from 'react';

/**
 * Stable function identity that always calls the latest `fn`.
 * Needed for `<Modal onClose>`: its focus effect depends on onClose, so a new function per render would move focus back
 * to the first input on every re-render (typing, refetch).
 */
export function useStableCallback<A extends unknown[], R>(fn: (...args: A) => R): (...args: A) => R {
  const ref = useRef(fn);
  useLayoutEffect(() => {
    ref.current = fn;
  });
  return useCallback((...args: A) => ref.current(...args), []);
}
